export default `<?xml version="1.0" encoding="UTF-8" standalone="yes" ?>
<wps:Execute
    service="WPS"
    version="1.0.0"
    xmlns:gml="http://www.opengis.net/gml"
    xmlns:wps="http://www.opengis.net/wps/1.0.0"
    xmlns:ows="http://www.opengis.net/ows/1.1"
    xmlns:wfs="http://www.opengis.net/wfs"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 ../wpsExecute_request.xsd"
>
    <ows:Identifier>Intersection</ows:Identifier>
    <wps:DataInputs>
        <wps:Input>
            <ows:Identifier>InputPolygon</ows:Identifier>
            <wps:Data>
                <wps:ComplexData
                    schema="http://foo.bar/MyComplexValueSchema.xsd"
                    mimeType="text/xml"
                    encoding="UTF-8"
                >
                    {INPUT1}
                    {INPUT2}
                </wps:ComplexData>
            </wps:Data>
        </wps:Input>
    </wps:DataInputs>
    <wps:ResponseForm>
        <wps:RawDataOutput>
            <ows:Identifier>intersectedPolygon</ows:Identifier>
        </wps:RawDataOutput>
    </wps:ResponseForm>
</wps:Execute>
`
